import dayjs from "dayjs";
import { formatDate } from "../../../utils/date";
import { formatNumber } from "../../../utils/number";
import { stripHtml } from "../../../utils/string";

/* Formatting helpers shared by the Job Portal pages. */

export const formatSalary = (
  min?: number | null,
  max?: number | null,
  isPublic = true,
) => {
  if (!isPublic || !min || !max) return "Negotiable";
  const fmt = (n: number) => formatNumber(n, { decimals: 0 });
  return `৳${fmt(min)} – ${fmt(max)}`;
};

/** "2" → "2 yrs", "0-1" → "0–1 yrs"; free text is left as is. */
export const formatExperience = (value?: string | null) => {
  if (!value) return "Not specified";
  const trimmed = value.trim();
  if (/^\d+(\s*-\s*\d+)?$/.test(trimmed)) {
    const text = trimmed.replace(/\s*-\s*/, "–");
    return trimmed === "0" ? "No experience" : `${text} yrs`;
  }
  return trimmed;
};

/** Plain-text preview of rich text, keeping a space between blocks. */
export const toPreview = (html?: string | null) =>
  stripHtml((html ?? "").replace(/<\/(p|li|h\d|div)>|<br\s*\/?>/gi, " "))
    .replace(/\s+/g, " ")
    .trim();

/** Deadline label with urgency, e.g. "Closes in 3 days". */
export const getDeadline = (deadline?: string | null) => {
  if (!deadline) return null;
  const days = dayjs(deadline)
    .startOf("day")
    .diff(dayjs().startOf("day"), "day");
  // Applying stays possible after the date (the API still lists these jobs).
  if (days < 0)
    return { label: `Deadline ${formatDate(deadline)}`, urgent: false };
  if (days === 0) return { label: "Closes today", urgent: true };
  if (days <= 7)
    return {
      label: `Closes in ${days} day${days > 1 ? "s" : ""}`,
      urgent: true,
    };
  return { label: `Closes ${formatDate(deadline)}`, urgent: false };
};
